import { z } from "zod";
import { channelCode, isoDate } from "./common.js";

export const channelSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  /** How many reviews reference this channel; a used channel cannot be deleted. */
  reviewCount: z.number().int().nonnegative(),
  /** How many active rule versions target this channel. */
  ruleCount: z.number().int().nonnegative(),
  createdAt: isoDate,
});
export type Channel = z.infer<typeof channelSchema>;

export const createChannelSchema = z.object({
  code: channelCode,
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(500).optional(),
  sortOrder: z.number().int().min(0).max(9999).optional(),
});
export type CreateChannelInput = z.infer<typeof createChannelSchema>;

// The code is immutable once reviews reference it, so only presentation and
// availability can change.
export const updateChannelSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  description: z.string().trim().max(500).nullable().optional(),
  sortOrder: z.number().int().min(0).max(9999).optional(),
  isActive: z.boolean().optional(),
});
export type UpdateChannelInput = z.infer<typeof updateChannelSchema>;
